import script from "./real-time-player.vue?vue&type=script&setup=true&lang=ts"
export * from "./real-time-player.vue?vue&type=script&setup=true&lang=ts"

import "./real-time-player.vue?vue&type=style&index=0&id=aba92f2e&lang=scss"

const __exports__ = script;

export default __exports__